import { render } from "./MobileRedirectPrompt.vue?vue&type=template&id=0f053a88&scoped=true"
import script from "./MobileRedirectPrompt.vue?vue&type=script&lang=js"
export * from "./MobileRedirectPrompt.vue?vue&type=script&lang=js"

import "./MobileRedirectPrompt.vue?vue&type=style&index=0&id=0f053a88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f053a88"]])

export default __exports__